import { useDispatch } from 'react-redux';
import {
  submit,
  submitError,
  submitRequest,
  submitDone,
} from '../../../Actions/Checkout.action';

import { object, string } from 'yup';
import { translate } from '../../../Services/translation';

const privateCustomerAddressSchema = object().shape({
  firstName: string().required(translate('validation.required')),
  lastName: string().required(translate('validation.required')),
  phoneNumber: string().required(translate('validation.required')),
  email: string()
    .required(translate('validation.required'))
    .email(translate('validation.email')),
  selectedResellerId: string().required(
    translate('validation.no_store_selected')
  ),
});

const businessCustomerDetailsSchema = object().shape({
  firstName: string().required(translate('validation.required')),
  lastName: string().required(translate('validation.required')),
  phoneNumber: string().required(translate('validation.required')),
  email: string()
    .required(translate('validation.required'))
    .email(translate('validation.email')),
});

const NON_CUSTOMER_DETAIL_FIELDS = [
  'selectedDeliveryMethod',
  'selectedPaymentMethod',
  'selectedResellerId',
];

export const useCheckoutFormSubmit = () => {
  const dispatch = useDispatch();

  const dispatchValidationError = (error, addressPath = 'customerDetails') => {
    let errorState = {};
    if (error.name === 'ValidationError' && error.inner?.length > 0) {
      error.inner.forEach((innerError) => {
        let errorPath = innerError.path;
        if (!NON_CUSTOMER_DETAIL_FIELDS.includes(errorPath)) {
          errorPath = `${addressPath}-${errorPath}`;
        }
        if (errorState[errorPath]) {
          errorState[errorPath].push(...innerError.errors);
        } else {
          errorState[errorPath] = [...innerError.errors];
        }
      });
    } else if (error.name === 'ValidationError') {
      let errorPath = error.path;
      if (!NON_CUSTOMER_DETAIL_FIELDS.includes(errorPath)) {
        errorPath = `${addressPath}-${errorPath}`;
      }
      errorState[errorPath] = [...error.errors];
    } else {
      errorState = error;
    }
    dispatch(submitError(errorState));
    dispatch(submitDone(null));
  };

  const validateAndSubmit = async (checkout) => {
    const { payload } = checkout || {};
    const {
      isBusinessCustomer,
      customerDetails,
      selectedDeliveryMethod,
      selectedPaymentMethod,
      selectedResellerId,
    } = payload || {};

    dispatch(submitRequest());

    try {
      if (isBusinessCustomer) {
        await businessCustomerDetailsSchema.validate(
          {
            ...customerDetails,
            selectedDeliveryMethod,
            selectedPaymentMethod,
          },
          { abortEarly: false }
        );
      } else {
        payload.showAlternativeAddress = false;
        await privateCustomerAddressSchema.validate(
          {
            ...customerDetails,
            selectedDeliveryMethod,
            selectedPaymentMethod,
            selectedResellerId,
          },
          {
            abortEarly: false,
          }
        );
      }

      dispatch(submit());
    } catch (error) {
      dispatchValidationError(error);
    }
  };

  return { validateAndSubmit };
};
